/* eslint-disable */
export default function objectDeepCopy(object, replace)
{
    const result = object.hasOwnProperty('constructor') ? new object() : {};

    Object.keys(object).forEach(function (key)
        {
            if (object[key] instanceof Array)
            {
                result[key] = (replace && replace.hasOwnProperty(key)
                        ? replace[key]
                        : object[key]
                ).map(function (i)
                {
                    return i instanceof Object ? objectDeepCopy(i) : i;
                });
            } else if (typeof object[key] === 'function')
            {
                result[key] = object[key];
            } else if (object[key] instanceof Object)
            {
                result[key] =
                    replace && replace.hasOwnProperty(key)
                        ? objectDeepCopy(replace[key])
                        : objectDeepCopy(object[key]);
            } else
            {
                result[key] =
                    replace && replace.hasOwnProperty(key) ? replace[key] : object[key];
            }
        }
    );

    return result;
}